<template>
    <v-row>
        <v-col>
            <SportipsButton v-if="bookingSystemStore.some_inscriptions_open" class="cursor_lock" action-button disabled
                icon="mdi-close">
                Ajouter un participant supplémentaire
                <v-tooltip activator="parent" location="top">Vous devez compléter
                    l'inscription ouverte avant de pouvoir ajouter un participant supplémentaire</v-tooltip>
            </SportipsButton>
            <SportipsButton v-else-if="bookingSystemStore.limit_inscription_vip_reached" class="cursor_lock"
                action-button disabled icon="mdi-close">
                Ajouter un participant supplémentaire
                <v-tooltip activator="parent" location="top">Vous avez atteint la
                    limite de participants de votre lien privilégié</v-tooltip>
            </SportipsButton>
            <SportipsButton v-else-if="!bookingSystemStore.has_unique_equipes_names" class="cursor_lock" action-button
                disabled icon="mdi-close">
                Ajouter un participant supplémentaire
                <v-tooltip activator="parent" location="top">Vous devez donner un nom valide et différent à chacune de
                    vos équipes</v-tooltip>
            </SportipsButton>
            <SportipsButton v-else icon="mdi-plus" @click="addInscription" chevron action-button> Ajouter un
                participant supplémentaire </SportipsButton>

        </v-col>
    </v-row>
</template>

<script>
import { mapStores } from "pinia";
import { useBookingSystemStore } from "@/stores/bookingSystemStore";
export default {
    name: 'ButtonAddInscription',
    computed: {
        ...mapStores(useBookingSystemStore),
    },
    methods: {
        addInscription() {
            this.bookingSystemStore.booking.addInscription();
        }
    }
}
</script>

<style scoped>
/* Add your styles here */
</style>